import pathToRegexp from 'path-to-regexp';

// this is a fork of matchPath from react-router with more typing

type CompiledPath = {
  regexp: RegExp;
  keys: pathToRegexp.Key[];
};
const cache: {
  [cacheKey: string]: {
    [path: string]: CompiledPath;
  };
} = {};

const cacheLimit = 10000;
let cacheCount = 0;

function compilePath(
  path: string,
  options:
    | (pathToRegexp.RegExpOptions & pathToRegexp.ParseOptions)
    | undefined = {}
) {
  const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
  const pathCache = cache[cacheKey] || (cache[cacheKey] = {});

  if (pathCache[path]) {
    return pathCache[path];
  }

  const keys: pathToRegexp.Key[] = [];
  const regexp = pathToRegexp(path, keys, options);
  const result: CompiledPath = { regexp, keys };

  if (cacheCount < cacheLimit) {
    pathCache[path] = result;
    cacheCount++;
  }

  return result;
}

export interface MatchOptions {
  path?: string | string[];
  exact?: boolean;
  strict?: boolean;
  sensitive?: boolean;
}

export default function matchPath(
  pathname: string,
  { path = [], exact = false, strict = false, sensitive = false }: MatchOptions
) {
  const paths = ([] as string[]).concat(path);

  return paths.reduce((matched, currentPath) => {
    if (matched) {
      return matched;
    }
    const { regexp, keys } = compilePath(currentPath, {
      end: exact,
      strict,
      sensitive,
    });
    const match = regexp.exec(pathname);

    if (!match) {
      return null;
    }

    const [url, ...values] = match;
    const isExact = pathname === url;

    if (exact && !isExact) {
      return null;
    }

    return {
      path: currentPath, // the path used to match
      url: currentPath === '/' && url === '' ? '/' : url, // the matched portion of the URL
      isExact, // whether or not we matched exactly
      params: keys.reduce(
        (memo, key, index) => {
          memo[key.name] = values[index];
          return memo;
        },
        {} as any
      ),
    };
  }, null);
}
